import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Layout from "./view";
import { authSliceSelector, login } from "../../slice";

export default function () {
    const history = useHistory();
    const authSlice = useSelector(authSliceSelector());
    const dispatch = useDispatch();

    const { accessToken, isLoading, apiErrors } = authSlice;

    useEffect(() => {
        if (accessToken) {
            history.push("/home");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accessToken]);

    const onFormSubmit = async (user) => {
        dispatch(login(user.email, user.password));
    };

    return (
        <Layout
            OnSave={onFormSubmit}
            isLoading={isLoading}
            apiErrors={apiErrors}
        />
    );
}
